<template>
  <div id="app relative">
    <transition name="fade" mode="out-in">
      <component :is="layout">
        <router-view />
      </component>
    </transition>
  </div>
</template>

<script>
import Navbar from '@/components/navbar'
import generateShareCard from '@jlengstorf/get-share-image'
import { provideStore } from './hooks/use-store'

const DEFAULT_LAYOUT = 'default'

export default {
  name: 'App',
  components: {
    Navbar
  },
  setup (props, { root: { store } }) {
    provideStore(store)
  },
  computed: {
    layout () {
      return (this.$route.meta.layout || DEFAULT_LAYOUT) + '-layout'
    }
  },
  metaInfo () {
    const shareImage = generateShareCard({
      cloudName: 'xtellar',
      title: ' ',
      imagePublicID: 'PhanerooPrayer/phaneroo-prayer-requests-dark'
    })

    return {
      title: 'Phaneroo Prayer Requests',
      titleTemplate: '%s | Phaneroo',
      meta: [
        {
          name: 'author',
          content: 'Phaneroo'
        },
        {
          name: 'image',
          content: shareImage
        },
        {
          name: 'description',
          content: 'Golden Altar for Phaneroo Prayer Requests'
        },
        {
          name: 'twitter:site',
          content: '@phanerookampala'
        },
        {
          name: 'twitter:title',
          content: 'Phaneroo Prayer Requests'
        },
        {
          name: 'twitter:card',
          content: 'summary_large_image'
        },
        {
          name: 'twitter:creator',
          content: '@phanerookampala'
        },
        {
          name: 'image',
          property: 'og:image',
          content: shareImage
        },
        {
          name: 'description',
          property: 'og:description',
          content: 'Golden Altar for Phaneroo Prayer Requests'
        }
      ]
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.main {
  margin-top: 52px;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
